module.exports = __webpack_public_path__ + "img/Youtorial-white.cf647307.png";